module.exports = __webpack_public_path__ + "static/media/search-icon.26aa7f48.svg";